<template>
  <b-modal
    v-if="connection"
    ref="modal"
    id="agConnModal"
    class="agModal"
    :class="{'agModal-loading':isLoading}"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="saveConnButton_click">
    <template slot="modal-header">
      <h4 v-if="isReadonly" class="agModal-title">View Connection</h4>
      <h4 v-else-if="isEditing" class="agModal-title">Edit Connection</h4>
      <h4 v-else class="agModal-title">New Connection</h4>
    </template>
    <b-input-group size="md" prepend="Name">
      <b-input type="text" v-model="connection.name" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    <div class="agInputGroup agInputGroupCentered">
      <label>Type:</label>
      <b-form-select
        class="agMediumInput"
        v-model="connection.type"
        :disabled="isReadonly"
        :options="types"
        style="width:200px;"
      ></b-form-select>
    </div>

    <b-input-group size="md" prepend="URL" v-if="visibleBase">
      <b-input type="text" v-model="connection.url" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    <hr />
    <b-input-group size="md" prepend="Username" v-if="visibleBase">
      <b-input type="text" v-model="connection.username" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Password" v-if="visibleBase">
      <b-input type="password" v-model="connection.password" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>

    <!-- components based on type -->

    <ag-agol-conn
      v-if="connection.type == 'agol'"
      ref="agol"
      :isReadonly="isReadonly"
      :connection="connection"
    ></ag-agol-conn>

    <ag-esri-conn
      v-if="connection.type == 'esri'"
      ref="esri"
      :isReadonly="isReadonly"
      :connection="connection"
    ></ag-esri-conn>

    <ag-geometry-conn
      v-if="connection.type == 'geometry'"
      ref="geometry"
      :isReadonly="isReadonly"
      :connection="connection"
    ></ag-geometry-conn>

    <ag-max-conn
      v-if="connection.type == 'max'"
      ref="max"
      :isReadonly="isReadonly"
      :connection="connection"
    ></ag-max-conn>

    <ag-sn-conn
      v-if="connection.type == 'snow'"
      ref="snow"
      :isReadonly="isReadonly"
      :connection="connection"
    ></ag-sn-conn>

    <ag-email-conn
      v-if="connection.type == 'email'"
      ref="email"
      :isReadonly="isReadonly"
      :connection="connection">
    </ag-email-conn>

    <ag-sms-conn
      v-if="connection.type == 'sms'"
      ref="sms"
      :isReadonly="isReadonly"
      :connection="connection">
    </ag-sms-conn>

    <ag-postgis-conn
      v-if="connection.type == 'postgis'"
      ref="postgis"
      :isReadonly="isReadonly"
      :connection="connection">
    </ag-postgis-conn>

    <vetro-conn
      v-if="connection.type == 'vetro'"
      ref="vetro"
      :isReadonly="isReadonly"
      :connection="connection">
    </vetro-conn>

    <snowflake-conn
      v-if="connection.type == 'snowflake'"
      ref="snowflake"
      :isReadonly="isReadonly"
      :connection="connection">
    </snowflake-conn>

     <http-conn
      v-if="connection.type == 'http'"
      ref="http"
      :isReadonly="isReadonly"
      :connection="connection">
    </http-conn>

    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <div v-if="warnings">
      <div id="agConnModal-warningLabel">
        <fa icon="exclamation-triangle" />Warning:
      </div>
      <div v-html="warnings"></div>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="success"
        :disabled="isLoading"
        @click="testConnButton_click"
      >Test</b-button>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="isReadonly || isLoading"
        @click="saveConnButton_click"
      >Save</b-button>
    </template>
  </b-modal>
</template>


<script>
// components
import AGOLConnection from "comp/connection/AGOLConnection";
import ESRIConnection from "comp/connection/ESRIConnection";
import GeometryConnection from "comp/connection/GeometryConnection";
import MaxConnection from "comp/connection/MaxConnection";
import EmailConnection from "comp/connection/EmailConnection";
import SNConnection from "comp/connection/SNConnection";
import SMSConnection from "comp/connection/SMSConnection";
import POSTGISConnection from "./POSTGISConnection.vue";
import VetroConnection from "./VetroConnection.vue";
import HTTPConnection from "./HTTPConnection.vue";
import SnowflakeConnection from "./SnowflakeConnection.vue";

// server

// modules
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-connection-modal",
  components: {
    "ag-agol-conn": AGOLConnection,
    "ag-esri-conn": ESRIConnection,
    "ag-geometry-conn": GeometryConnection,
    "ag-max-conn": MaxConnection,
    "ag-email-conn": EmailConnection,
    "ag-sn-conn": SNConnection,
    "ag-sms-conn": SMSConnection,
    "ag-postgis-conn":POSTGISConnection,
    "vetro-conn":VetroConnection,
    "http-conn":HTTPConnection,
    "snowflake-conn":SnowflakeConnection
  },
  props: {
    connection: Object
  },

  data() {
    return {
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      warnings: "",
      errorField: ""
    };
  },

  computed: {
    isReadonly() {
      if (this.user.role == "readonly") return true;
      return false;
    },

    isEditing() {
      if (this.connection._id) return true;
      return false;
    },

    visibleBase() {
      return this.connection.type != "sms" && this.connection.type != "vetro"  && this.connection.type != "http" && this.connection.type != "snowflake";
    },

    user() {
      return this.$store.state.userStore.user;
    },

    connections() {
      return this.$store.state.connStore.connections;
    },

    types() {
      var myTypes = [
      {
      value:"esri",
      text:"esri",
      type:"esri"
      },
      {
      value:"email",
      text:"email",
      type:"email"
      },
      {
      value:"agol",
      text:"agol",
      type:"agol"
      },
      {
      value:"geometry",
      text:"geometry",
      type:"geometry"
      },
      {
      value:"postgis",
      text:"postgis",
      type:"postgis"
      },
       {
      value:"vetro",
      text:"vetro",
      type:"vetro"
      },
      {
      value:"snowflake",
      text:"snowflake",
      type:"snowflake"
      },
       {
      value:"http",
      text:"http",
      type:"http"
      }];
      // var conns = this.$store.state.modules.map(a => a.connections);
      for (let i = 0; i < myTypes.length; i++) {
        let conn = myTypes[i];
        for (let j = 0; j < conn.length; j++) {
          let ctype = conn[j];
          myTypes.push({ value: ctype.name, text: ctype.text });
        }
      }
      myTypes.push({ value: "sms", text: "Text Message"})
      return myTypes;
    }
  },

  methods: {
    // UI Events

    async saveConnButton_click() {
      var valid = await this.validate();
      if (!valid) return;

      // alert subcomponent
      var subcomponent = this.$refs[this.connection.type];
      subcomponent.prepareForSave();

      if (this.isEditing) var func = "updateConnection";
      else var func = "insertConnection";

      this.isLoading = true;
      var result = await this.$store.dispatch("connStore/" + func, {
        connection: this.connection
      });
      this.isLoading = false;
      if (result.data.success) {
        // hide modal and reset values
        this.hide();
        this.$emit("reloadConnections");
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    testConnButton_click() {
      this.validate();
    },

    // other

    show() {
      setTimeout(() => {
        this.reset();
        this.$refs.modal.show();
      }, 250);
    },

    hide() {
      this.$refs.modal.hide();
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.warnings = "";
    },

    hasError(field) {
      if (field == this.errorField) {
        return false; // false = error
      }
      return null;
    },

    async validate() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.warnings = "";

      // validate fields
      if (!this.connection.name) {
        this.modalMessage = "Name is required";
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "name";
        return false;
      }

      var sameNameConn = this.connections.find(
        a => a.name == this.connection.name
      );
      if (
        sameNameConn &&
        (!this.connection._id || sameNameConn._id != this.connection._id)
      ) {
        this.modalMessage =
          'A connection named "' +
          this.connection.name +
          '" already exists in this workspace';
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "name";
        return false;
      }

      try {
        this.isLoading = true;
        var result = await Server.post("validateConnection", {
          connection: this.connection
        }).promise;
        this.isLoading = false;
        if (!result.data.success) throw result.data.error;

        if (result.data.isValid) {
          if(result.data.version)
            this.connection.version = result.data.version;
          this.modalMessage = "Connection valid";
          this.modalMessageClass = "agModal-successMessage";
          if (result.data.warnings) {
            for (let i = 0; i < result.data.warnings.length; i++) {
              this.warnings += "<label>" + result.data.warnings[i] + "</label>";
            }
          }
          return true;
        } else {
          this.modalMessage = "Connection failed: " + result.data.error;
          this.modalMessageClass = "agModal-errorMessage";
          this.errorField = "url";
          return false;
        }
      } catch (e) {
        this.isLoading = false;

        this.modalMessage = e.toString();
        this.modalMessageClass = "agModal-errorMessage";
        this.errorField = "url";
        return false;
      }
    }
  }
};
</script>


<style scoped lange="css">
#agConnModal-warningLabel {
  font-weight: bold;
  margin-bottom: 5px;
}

#agConnModal-warningLabel svg {
  margin-right: 10px;
  color: #ffd40f;
}
</style>


// WEBPACK FOOTER //
// src/components/connection/ConnectionModal.vue